export default [
  {
    title: 'رزرو غذا',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'منوی غذا',
        icon: 'Edit3Icon',
        route: 'FoodMenu_Create',
        permission: 'food-menus.index',
      },
      {
        title: 'رزرو غذا',
        icon: 'SendIcon',
        route: 'Reservation',
        permission: 'reservations.index',
      },

      {
        title: 'رزرو خاص',
        icon: 'ArchiveIcon',
        route: 'Reservation_Special',
        permission: 'special-reservations.index',
      },

      {
        title: 'گزارشگیری',
        icon: 'ArchiveIcon',
        route: 'Reservation_Report',
        permission: 'reservations.report',
      },

      {
        title: 'وعده غذایی',
        icon: 'SunriseIcon',
        children: [
            {
                title: 'لیست وعده ها',
                permission: 'meals.index',
                route: 'Meal_List',
            },
            {
                title: 'ایجاد وعده',
                permission: 'meals.store',
                route: 'Meal_Create',
            },
        ]
      },

      {
        title: 'تعریف غذا',
        icon: 'SunriseIcon',
        children: [
            {
                title: 'لیست غذاها',
                permission: 'foods.index',
                route: 'Food_List',
            },
            {
                title: 'ایجاد غذا',
                permission: 'foods.store',
                route: 'Food_Create',
            },
        ]
      }
    ]
  }
]
